export default __webpack_public_path__ + "static/media/count.f89c5fa1.wav";